<template>
  <div class=" px-5 mx-7 pt-5">
    <Card :title="$t('tasks.list')" containerClass="mb-5">
      <template #cardBody>
        <div class="row">
          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="tasks_datatable">
            <thead>
              <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <th class="min-w-150px">{{ $t('tasks.table.title') }}</th> 
                <th >{{ $t('tasks.table.createdAt') }}</th>
                <th >{{ $t('tasks.table.createdBy') }}</th>
                <th >{{ $t('tasks.table.priority') }}</th>
                <th >{{ $t('tasks.table.category') }}</th>
                <th >{{ $t('tasks.table.statut') }}</th>
                <th >{{ $t('action') }}</th>
              </tr>
            </thead>
          </table>
        </div>
      </template>
    </Card>
  </div>

  <UpdateTaskModal id="update_modal_task" :formEdit="formEditTaskData" @load="fetchDatas"/>
  <AddSubTaskModal id="add_sub_task_modal" :task-id="formEditTaskData.task_id" @callback="fetchDatas"/>
  <AttachFileToTaskModal id="attach_file_to_task_modal" :task-id="formEditTaskData.task_id" @callback="fetchDatas"/>
  <SendTaskCommentModal id="send_task_comment_modal" :task-id="formEditTaskData.task_id" @callback="fetchDatas"/>
</template>

<script setup>
import {computed, defineProps, inject, onMounted, ref, watch} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import Ls from "@/services/ls";
import {useHasAbility} from "@/composables/hasAbility";
import {useLocales} from "@/composables/locales";
import { BASE_URL } from "@/services/api";
import Card from "@/Modules/CRM/components/Card";
import {Theme} from "@/composables/theming";
import UpdateTaskModal from "../../components/Modals/Task/UpdateTaskModal.vue";
import {$dateFormatter} from "@/mixins/Helpers";
import {useModelViewType} from "@/composables/modelViewType";
import {useProjectEnums} from "@/Modules/Projects/composables/projectEnums";
import SendTaskCommentModal from "@/Modules/Projects/components/Modals/Task/SendTaskCommentModal.vue";
import AddSubTaskModal from "@/Modules/Projects/components/Modals/Task/AddSubTaskModal.vue";
import AttachFileToTaskModal from "@/Modules/Projects/components/Modals/Task/AttachFileToTaskModal.vue";
import {format} from "date-fns";
import {useSwal} from "@/composables/useSwal";

const store = useStore()
const router = useRouter()
const route = useRoute()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()
const { modelViewType } = useModelViewType()
const { taskQuickActions } = useProjectEnums()

const {showSwal} = useSwal()
const emitter = inject('emitter')

const props = defineProps({
  filter: {
    type: Object,
    default: () => ({
      startDate: '',
      endDate: '',
      status: '',
      contact: '',
      search: '',
      priority: ''
    })
  },
  openNewTaskModal:Function
})
const table = ref(null)
const formData = ref({})
const formEditTaskData = ref({
  task_id: ''
})

const query = ref(props.filter)

watch(() => props.filter, (value) => {
  fetchDatas()
}, {deep: true})

watch(() => route.query, (value) => {
  if(value && value.viewType === modelViewType.value.list) {
    fetchDatas()
  }
}, { deep: true})

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  table.value = $("#tasks_datatable").DataTable({ 
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url: BASE_URL + `/tasks/project/${route.params.id}/details/datatables?start_date=${props.filter.startDate}&end_date=${props.filter.endDate}&task_status_id=${props.filter.status}&project_category_step_id=${props.filter.milestone}&task_priority_id=${props.filter.priority}`,
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
        //Access-Control-Allow-Origin: *
        request.setRequestHeader("Access-Control-Allow-Origin", "*");
      }
    },
    columns: [
      { data: "title" }, { data: "created_at" }, { data: "created_by" },{ data: "priority" }, { data: "category" },{ data: "status" }, { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
    {
        targets: -7,
        order: "desc",
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -6,
        order: "desc",
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + $dateFormatter(t, locale.value) + "</span>";
        },
      },
      {
        targets: -5,
        order: "desc",
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -4,
        order: "desc",
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },

      {
        targets: -3,
        orderable: false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t.title + "</span>";
        },
      },

      {
        targets: -2,
        orderable: false,
        className: "dt-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t  + "</span>";
        },
      },


      {
        targets: -1,
        "className": "dt-center text-center",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render="<div class='d-flex align-items-center'> "
          render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-name="${e.name}" class="btn btn-sm btn-clean btn-icon show_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}" data-name="${e.name}" class="fas fa-eye fs-2" style="color: ${Theme.gray}" ></i></a>`;
          render += `<div class="dropdown">
                      <button class="btn btn-sm btn-clean btn-icon ms-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-ellipsis-v fs-2 text-dark cursor-pointer "></i>
                      </button>
                      <ul class="dropdown-menu">
                        ${generateTaskQuickAction(e.id)}
                      </ul>
                    </div>`

          render += '</div>'
          return render
        },
      },

    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  table.value.on("click", ".show_btn", (e) => {
    router.push({ name: 'tasks-view', params: { id: e.target.getAttribute('data-id'), project: route.params.id } })
  });

  table.value.on("click", ".quickAction", (e) => {
    const target = e.target.closest('.quickAction');
    handleTaskAction(target.getAttribute('data-task'), target.getAttribute('data-action'))
  });

  table.value.on("click", ".edit_btn", (e) => {
    openEditModal()
  });

}

function generateTaskQuickAction(taskId) {
  let actions = ''
  Object.keys(taskQuickActions.value).forEach((action) => {
    actions += `
        <li>
          <a
            href="javascript:;"
            class="dropdown-item d-flex align-items-center quickAction"
            data-task="${taskId}"
            data-action="${action}"
            style="cursor: pointer;"
          >
              <span><i  data-task="${taskId}"
                        data-action="${action}"
                        class="${taskQuickActions.value[action]?.icon} me-3">
                    </i>
                ${i18n.global.t(taskQuickActions.value[action]?.name)}
              </span>
          </a>
        </li>
    `
  })

  return actions
}

function handleTaskAction(taskId, action) {

  switch (action) {
    case taskQuickActions.value.EDIT.value:

      store.dispatch('tasks/getTask', taskId)
          .then(({data: response}) => {
            const task = response.data

            if (task.id) {
              formEditTaskData.value = {
                id: task?.id,
                title: task?.title,
                project_id: task?.project_id,
                project_category_step_id: task?.project_category_step_id,
                task_status_id: task?.taskStatus?.id,
                task_priority_id: task?.task_priority_id,
                description: task?.description,
                users: task?.users?.map(el => el?.id),
                delay_value: task?.delay_value,
                delay_unit: task?.delay_unit,
                delay_value_alert: task?.delay_value_alert,
                delay_unit_alert: task?.delay_unit_alert,
                delay_value_critical: task?.delay_value_critical,
                delay_unit_critical: task?.delay_unit_critical,
                start_date: task?.startDate && format(task?.startDate, 'dd-MM-yyyy HH:mm'),
                end_date: task?.endDate && format(task?.endDate, 'dd-MM-yyyy HH:mm'),
                task_id: task?.id,
                need_review: task?.need_review
              }
              $('#update_modal_task').modal('toggle')
            }
          }).catch()
      break;

    case taskQuickActions.value.DELETE.value:
      showSwal(
          i18n.global.t('swal.task_delete'),
          i18n.global.t('swal.task_delete_text')
      ).then(async (result) => {
        if (result.value) {

          store.dispatch('tasks/deleteTask', taskId)
              .then((res) => loadTaskByStatus(true))
              .catch()

        }
      })
      break;

    case taskQuickActions.value.ADD_SUB_TASK.value:
      formEditTaskData.value = {
        task_id: taskId,
      }
      $('#add_sub_task_modal').modal('toggle')
      break;

    case taskQuickActions.value.ADD_COMMENT.value:
      formEditTaskData.value = {
        task_id: taskId,
      }
      $('#send_task_comment_modal').modal('toggle')
      break;

    case taskQuickActions.value.ADD_FILE.value:
      formEditTaskData.value = {
        task_id: taskId,
      }
      $('#attach_file_to_task_modal').modal('toggle')
      break;
  }
}

function openEditModal(){
  $('#update_modal_task').modal('toggle')
}

onMounted(() => {
  store.dispatch('company/generalInformation')
  store.dispatch('appointments/loadRecurrenceFrequencyEnum')
  fetchDatas()
})

</script>

<style scoped>

</style>

